export const B1 = '#3366CC';

export const P3 = '#5786E3';
export const P4 = '#4E80E3';
export const P5 = '#345FB2';
export const P6 = '#204794';

export const S1 = '#FFFFFF';
export const S2 = '#F0F3FB';
export const S3 = '#D2D8DC';
export const S4 = '#83929C';
export const S5 = '#5D6169';
export const S6 = '#333333';

export const AG1 = '#26D777';
export const AG2 = '#1AC769';
export const AG3 = '#7FB434';
export const AG4 = '#F5FFE8';

export const AR1 = '#DF4935';
export const AR2 = '#D34431';
export const AR4 = '#FBE8E6';

export const AO1 = '#FFF0DF';
export const AO2 = '#F9A440';
export const AO3 = '#F2994A';
export const AO4 = '#FF9314';

export const AB1 = '#D8E6FC';
export const AB2 = '#3A9DF9';
export const AB3 = '#1084EF';
export const AB4 = '#A5C0FD';
export const AB5 = '#7C9DE3';

export const AY1 = '#F3DD18';

export const boxShadow = '0px 4px 4px rgba(51, 51, 51, 0.25)';
export const boxShadow2 = '0px 4px 30px rgba(0, 0, 0, 0.1)';
